import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LazyLoadScriptService } from './../sidebar/lazy-load-script.service'
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-operations',
    templateUrl: './operations.component.html',
    styleUrls: ['./operations.component.css']
})

export class OperationsComponent implements OnInit {
    imageoneOperations: boolean = false;
    pageTitle: string;
    pageDisplay: string;
    id: number;

    constructor(
        private activatedroute: ActivatedRoute,
        private router: Router,
        private lazyLoadService: LazyLoadScriptService
    ) { }

    ngOnInit(): void {
        var applicationName = "operationssappelement";

        this.lazyLoadService.loadScript(environment["OPERATIONAPPURL"], applicationName).subscribe(_ => {
            let url = this.router.url;
            if (url.includes('/operations/inspectionlist')){
                this.pageTitle = "Inspection List";
                this.pageDisplay = "inspectionList";
            } else if (url.includes('/operations/pricemap')) {
                this.pageTitle = "Map by Price";
                this.pageDisplay = "priceMap";
            } else if (url.includes('/operations/statusmap')) {
                this.pageTitle = "Map by Status";
                this.pageDisplay = "statusMap";
            }  else if (url.includes('/operations/inspectiondetail')) {
                this.pageTitle = "Inspection";
                this.pageDisplay = "inspectionDetail";
            } else if (url.includes('/operations/clientdetail')) {
                this.pageTitle = "Client Details";
                this.pageDisplay = "clientDetail";
            } else if (url.includes('/operations/inspectionreports')) {
                this.pageTitle = "Inspection Reports";
                this.pageDisplay = "inspectionReports";
            } else if (url.includes('/operations/averagescore')) {
                this.pageTitle = "Average Inspection Scores";
                this.pageDisplay = "averageScore";
            }else if (url.includes('/operations/clientattention')) {
                this.pageTitle = "Clients that need Attentions";
                this.pageDisplay = "clientAttention";
            }else if (url.includes('/operations/inspcompleted')) {
                this.pageTitle = "Inspection Completed";
                this.pageDisplay = "inspCompleted";
            }else if (url.includes('/operations/inspectionreportdetail')) {
                this.pageTitle = "Inspection Report Details";
                this.pageDisplay = "inspectionReportDetail";
            }else if (url.includes('/operations/viewinspectionreportdetail')) {
                this.pageTitle = "Inspection Report Details";
                this.pageDisplay = "viewInspectionReportDetail";
            } else if (url.includes('/servicearea')) {
                this.pageTitle = "Services and Areas";
                this.pageDisplay = "servicesAndAreas";
            } else if (url.includes('/supplyrequests/') && url.match(/\/operations\/supplyrequests\/\d+/)) {
                // Extract the ID from the URL for supply request details
                const matches = url.match(/\/operations\/supplyrequests\/(\d+)/);
                this.id = matches ? parseInt(matches[1]) : 0;
                this.pageTitle = "Supply Request Summary";
                this.pageDisplay = "supplyRequestDetail";
            } else if (url.includes('/supplyrequests')) {
                this.pageTitle = "Supply Requests";
                this.pageDisplay = "supplyRequests";
            } else if (url.includes('/supplymanagement')) {
                this.pageTitle = "Supply Management";
                this.pageDisplay = "supplyManagement";
            }
            else if (url.includes('/operations/timecards')) {
                this.pageTitle = "Time Cards";
                this.pageDisplay = "timecards";
            }
            else if (url.includes('/operations/incident-reports/') && url.match(/\/operations\/incident-reports\/\d+/)) {
                const matches = url.match(/\/operations\/incident-reports\/(\d+)/);
                this.id = matches ? parseInt(matches[1]) : 0;
                this.pageTitle = "Incident Report Detail";
                this.pageDisplay = "incidentReportDetail";
            }
            else if (url.includes('/operations/incident-reports')) {
                this.pageTitle = "Incident Reports";
                this.pageDisplay = "incidentReports";
            }
            
            this.imageoneOperations = true;
        });

    }

    ngOnDestroy(): void {
        this.imageoneOperations = false;
    }
}